import { render } from "./ChannelSubscriptionGift.vue?vue&type=template&id=eefd66a4"
import script from "./ChannelSubscriptionGift.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriptionGift.vue?vue&type=script&lang=ts"
script.render = render

export default script